export class GlobalOperations {
  static BaseUrl: string = "https://yenimahalle-web-api.alsft.com/api";
  

  static get isProd(): boolean {
    return GlobalOperations.BaseUrl === "https://yenimahalle-web-api.alsft.com/api";
  }
  static IsNullOrEmpty(value: string | null | undefined): boolean {
    return value === null || value === undefined || value.trim() === "";
  }

  static consoleLog(data: object) {
    if (!GlobalOperations.isProd) {
      console.log(data);
    }
  }
}
